import React from "react";
import PopUpItem from "./../../PopUp/PopUpItem";
import PopUpOther, { CreditCode, SERIALNUMBER } from "../../PopUp/PopUpOther";

import PopUpwarehouse from "./../../PopUp/PopUpwarehouse";
import PopUpSELSTKMOVEREQ from "./../../PopUp/PopUpSELSTKMOVEREQ";
import { ReDate } from "./../../_source/Datefn";
import { Row, Grid, Col, Panel } from "react-bootstrap";
import {
  genURL,
  gengetURLTEST,
  genpostURL,
  genpostURLTEST,
} from "./../../_getjson";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Checkdocgroup from "./../../CustomFunction/Docgroup/Checkdocgroup";
import Chackdocno from "./../../CustomFunction/Docno/GetDocno";
import CheckUser from "./../../CustomFunction/Csuser/GetUser";
import PopUpReport from "./../../PopUp/_fromShow";
import { parseJwt } from "../../parseJWT";
import axios from "axios";
import Backdrop from "./../../Components/CustomBackdrop/Barckdrop";
import Snackbar from "./../../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import { Grid as MuiGrid } from "@mui/material";
// import { checkunit } from '../../_source/checkUnit'
import Checkstock from "./../../CustomFunction/Product/ChkStock";
import MaterialUIPickers from "./../../Components/CustomDatepicker/MaterialUIPickers";
import CustomInput from "./../../Components/CustomInput/Inputtext";
import Topbar from "./../../Components/Customtopbar/Topbar";
import FullScreenDialog from "../../PopUp/FullScreendialogs/FullScreen";

import FullScreenDialognew from "../../Components/CustomDialogs/Fullscreendialog";
import Repostview from "../../Components/Reportview/Repostview";
import Rechecked from "./Components/Rechecked";
import CheckCodeDocGroup from "../../CustomFunction/Docgroup/CheckCodeDocGroup";
import WarehouseTransfer from "./Components/warehouse_out_in";

const rowNum = 300;
const listmenu = [["เลือกใบขอโอน", "SELSTKMOVEREQ"]];
export const setRow = (count) => {
  var data = [];
  for (var i = 0; i <= count - 1; i++) {
    data[i] = { C0: i + 1 };
  }
  return data;
};
// const [alignment, setAlignment] = React.useState('web');

export default class index extends React.Component {
  // ฟังก์ชันสำหรับเคลียร์ค่าทุก input
  clearAllInputs = () => {
    // เคลียร์ค่าทุก ref
    if (this.Groupdata_code.current) this.Groupdata_code.current.value = "";
    if (this.Groupdata.current) this.Groupdata.current.value = "";
    if (this.DeliNumber.current) this.DeliNumber.current.value = "";
    if (this.Remark.current) this.Remark.current.value = "";
    if (this.Csuser.current) this.Csuser.current.value = "";
    if (this.Csuser_code.current) this.Csuser_code.current.value = "";
    if (this.barcode.current) this.barcode.current.value = "";
    if (this.MileNo.current) this.MileNo.current.value = "";
    if (this.TransferName.current) this.TransferName.current.value = "";
    if (this.SerialNo.current) this.SerialNo.current.value = "";
    if (this.Ref_docno.current) this.Ref_docno.current.value = "";
    // เคลียร์ state ที่เกี่ยวข้อง
    this.setState({
      SaleDate: "",
      Groupdata_txt: "",
      products: setRow(rowNum),
      messagealert: "",
      color: "warning",
      TBLastClick: -1,
      WHRow: 0,
      openBackdrop: false,
      formPrintdata: "",
      reporturl: "",
    });
  };
  constructor(props) {
    super(props);
    this.Groupdata_code = React.createRef();
    this.Groupdata = React.createRef();
    this.DeliNumber = React.createRef();
    this.Remark = React.createRef();
    this.Csuser = React.createRef();
    this.Csuser_code = React.createRef();
    this.barcode = React.createRef();
    this.MileNo = React.createRef();
    this.TransferName = React.createRef();
    this.SerialNo = React.createRef();
    this.Ref_docno = React.createRef();
    this.state = {
      TBLastClick: -1,
      C1_editable: false,
      siteCodeUser: "",
      Groupdata_txt: "",
      WHRow: 0,
      openBackdrop: false,
      autoClose: 3600,
      color: "warning",
      messagealert: "",
      usercode: "",
      checkenableInput: [],
      defaultwarehouse: "",
      defaultlocetion: "",
      defaultendwarehouse: "",
      defaultendlocetion: "",
      reporturl: "",
      formPrintdata: "",
    };
  }
  async componentDidMount() {
    //เช็คเปิดปิด textbox
    await this.setState({
      checkenableInput: JSON.parse(localStorage.getItem("checkoftxt")),
    });

    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
    this.setState({ usercode: SITECODESTR.User.CODE });
    this.setwarehoust();
    this.setState({ products: setRow(rowNum) });
    this.onAddValue("Csuser", SITECODESTR.User.CODE);
    this.MileNo.current.value = parseFloat(0).toFixed(2);

    let mid = new URLSearchParams(location.search).get("mid");
    this.loadFromindb(mid);
  }

  loadFromindb = async (mid) => {
    //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ
    console.log("res.data", mid);
    let url = `reportmanage/reportform/${mid}?`;
    console.log("res.data", genURL(url));
    let res = await axios.get(genURL(url));
    if (res.data.length > 0) {
      await this.setState({ reporturl: res.data[0].pathname });
      await this.setState({ formPrintdata: res.data });
    }
  };

  setwarehoust() {
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({ defaultwarehouse: SITECODESTR.User.SITECODE });
    this.setState({ defaultlocetion: SITECODESTR.User.SITECODE + "001" });
  }

  escapeRegExp(str) {
    return str.replace(/,/g, " ");
  }

  saveData = async () => {
    const parameter = new URLSearchParams();
    var productCODE = "",
      productNAME = "",
      qty = "",
      WAREHOUSE = "",
      WAREHOUSE1 = "",
      LOCATION = "",
      LOCATION1 = "",
      UNITCODE = "",
      WAREHOUSEIN = "",
      LOCATIONIN = "";
    var REFDOCNO = "",
      REFQTY = "0";

    let items = [];
    let Data = [];

    if (this.state.products[0].T_Code) {
      for (
        var i = 0;
        i < this.state.products.length && this.state.products[i].T_Code;
        i++
      ) {
        if (
          this.state.products[i].T_Code !== "" &&
          this.state.products[i].T_Warehouse === ""
        ) {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ให้กำหนดคลังเข้าในตารางสินค้าก่อน" });
          return;
        }

        if (this.state.products[i].T_StorageOut === "") {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ให้กำหนดคลังจ่ายในตารางสินค้าก่อน" });
          return;
        }
        if (this.state.products[i].T_Quantity === "0.00") {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ให้กำหนดปริมาณก่อน" });
          return;
        }
        Data[i] = {
          Productcode: this.state.products[i].T_Code, //productCODE 0
          Productname: this.state.products[i].T_List, //productNAME 1
          Quantity: this.state.products[i].T_Quantity, //qty 2
          Warehouse: this.state.products[i].treasury, //WAREHOUSE3
          Location: this.state.products[i].T_StorageOut, //Location 4
          Unitcode: this.state.products[i].T_Unit_Code, //Unitcode 5
          Warehousein: this.state.products[i].T_Warehouse,
          Locationin: this.state.products[i].T_StorageIn,
          Refdocno: this.state.products[i].REFDOCNO.toString(), //ITEMTAXTYPE
          Refqty: this.state.products[i].REFQTY,
        };
        items.push(Data[i]);

        // let warehouse = this.DeliNumber.current.value.substring(2, 6)
        // console.log(warehouse, "this.state.products.treasury", this.state.products[i].treasury);

        // if (warehouse !== this.state.products[i].treasury) {
        //     this.setState({ opensnackbar: true })
        //     this.setState({ color: "warning" })
        //     this.setState({ icon: ErrorIcon })
        //     this.setState({ messagealert: "คลังจ่ายหรือที่เก็บจ่ายไม่ถูกต้อง" })
        //     return
        // }
        let url = `CSPRODUCT/GetcountStock?productcode=${this.state.products[i].T_Code}&provenance=&unitcode=${this.state.products[i].T_Unit_Code}&warehouse=${this.state.products[i].treasury}&location=${this.state.products[i].T_StorageOut}`;
        // https://psmtapi.pspl.co.th/CSPRODUCT/GetcountStock?api_key=eNGLtwXPd8hKPre0H4nBaqHMiYp7kpGPhnypqjdW&jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2MzU1MDY3NzksIlVzZXIiOnsiQ09ERSI6IjUxMDI0IiwiU0lURUNPREUiOiIxMDAyIiwiVVNFUkdST1VQIjoiMDUifX0.U1lXsDqx4QumRtkXVFLV81H2S8gqxyxlGcox-6jlapc&productcode=00001881&provenance=&unitcode=02&warehouse=1009&location=1009001
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then((res) => {
          console.log("GetcountStock", res);
          if (Number(res.data.SaleStock) < 0) {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                "จำนวนสินค้ารหัส " +
                this.state.products[i].T_Code +
                " ไม่พอใช้งาน",
            });
            return;
          }
        });
      }
      // var group = this.Groupdata_code.current.value.substring(2, 6);
      // WAREHOUSE1 = WAREHOUSE.split("|")
      // for (let i = 0; i < WAREHOUSE1.length; i++) {
      //     console.log(group, "===", WAREHOUSE1[i]);
      //     if (group !== WAREHOUSE1[i]) {
      //         this.setState({ opensnackbar: true })
      //         this.setState({ color: "warning" })
      //         this.setState({ icon: ErrorIcon })
      //         this.setState({ messagealert: "เลือกคลังหรือตำแหน่งเก็บไม่ถูกต้องกรุณาตรวจสอบด้วยครับ" })
      //         return
      //     }
      // }
    } else {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "ให้กำหนดข้อมูลในตารางสินค้าก่อน" });
      return;
    }
    /* Success */
    parameter.append("DEVICECODE", "DEVICECODE");
    parameter.append("USER", localStorage.getItem("Username"));
    parameter.append("DOCDATE", this.state.SaleDate); //วันที่โอน
    parameter.append("DOCNO", this.DeliNumber.current.value); //เลขที่ใบโอน
    parameter.append("REMARK", this.Remark.current.value); //หมายเหตุ
    parameter.append("DOCGROUP", this.Groupdata_code.current.value); //กลุ่มข้อมูล
    parameter.append("listItem", JSON.stringify(items));
    // parameter.append("PRODUCTCODE", productCODE);
    // parameter.append("PRODUCTNAME", productNAME);
    // parameter.append("QUANTITY", qty);
    // parameter.append("WAREHOUSE", WAREHOUSE);
    // parameter.append("LOCATION", LOCATION);
    // parameter.append("UNITCODE", UNITCODE);
    // parameter.append("WAREHOUSEIN", WAREHOUSEIN);
    // parameter.append("LOCATIONIN", LOCATIONIN);
    // parameter.append("REFDOCNO", REFDOCNO);
    // parameter.append("REFQTY", REFQTY);
    parameter.append(
      "provenance",
      window.location.hostname === "localhost" ? "" : "Web"
    );
    var Uststus = true;
    for (var pair of parameter.entries()) {
      console.log(pair[0], "==", pair[1]);
      if (pair[0] === "DOCGROUP" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" });
        this.Groupdata.current.focus();
      }
    }
    if (Uststus === true) {
      this.setState({ openBackdrop: true });
      parameter.append(
        "MileNo",
        this.MileNo.current.value == "" ? 0.0 : this.MileNo.current.value
      ); //เลขไมล์
      parameter.append("SerialNo", this.SerialNo.current.value); //หมายเลขตัวถัง
      parameter.append("TransferName", this.TransferName.current.value); //ผู้รับโอน
      parameter.append("Ref_docno", this.Ref_docno.current.value); //อ้างอิงขอโอนเลขที่

      await axios
        .post(genpostURL(`CSSTKMOVE/Save?user=`), parameter)
        .then((res) => {
          //  await axios.post(genpostURLTEST(`/Save?user=`), parameter).then(res => {
          if (res.data.status === "success") {
            this.setState({ opensnackbar: true });
            this.setState({ color: "success" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกสำเร็จ" });
            setTimeout(() => {
              this.setState({ openBackdrop: false });
              if (this.state.reporturl !== "") {
                this._printReport(res.data.docno);
              } else {
                this.ReplacePage(window.location.pathname + location.search);
              }
            }, 30);
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert: "บันทึกไม่สำเร็จ : " + res.data.status,
            });
            this.setState({ openBackdrop: false });
          }
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
          this.setState({ openBackdrop: false });
        });
    }
  };

  Get_PopUpOther = async (val) => {
    var data = val.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        this.Groupdata_code.current.value = data[0];
        this.Groupdata.current.value = data[1];
        this.setState({ Groupdata_txt: data[1] });
        await Chackdocno(data[0], "CSSTKMOVE")
          .then(async (result1) => {
            console.log("result1", result1);
            if (result1 !== undefined) {
              this.DeliNumber.current.value = await result1;
            } else {
              this.DeliNumber.current.value = "";
            }
          })
          .catch((err) => {
            this.DeliNumber.current.value = "";
            console.log(err);
          });
        break;
      default:
        break;
    }
  };
  Get_PopUpSERIALNUMBER = (data1, data2) => {
    var dataArray = this.state.products;
    dataArray[this.state.se_Row - 1].SERIALNUMBER = data2.SERIALNUMBER;
    dataArray[this.state.se_Row - 1].treasury = data2.WAREHOUSE;
    dataArray[this.state.se_Row - 1].T_StorageOut = data2.LOCATION;
    this.setState({ products: dataArray });
  };
  CalendarOnChange = (data, DateUp) => {
    var Backup = "";
    var today = new Date(data);
    if (DateUp) {
      today.setDate(today.getDate() + DateUp);
    }
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + (yyyy + 543);

    setTimeout(() => {
      Backup = this.state.MenuItem;
      this.setState({ MenuItem: "" });
    }, 0);
    setTimeout(() => {
      this.setState({ MenuItem: Backup });
    }, 10);
    return today;
  };
  /*---------------------------------------------vvvvvvvvvvvvvvv---center---vvvvvvvvvvvvvvv---------------------------------------------*/
  _cellButton(cell, row, enumObject, rowIndex) {
    var btn = this.state.products[rowIndex].BTN_Code;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={(_) => this.Switch_PopUpItem("SearchItem", row.C0)}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButton_BTNC3 = (cell, row, enumObject, rowIndex) => {
    return this._cellButtonWH(row.BTN_Paybills, "InC3");
  };
  _cellButton_BTNC4 = (cell, row, enumObject, rowIndex) => {
    return this._cellButtonWH(row.BTN_Storage, "InC4");
  };
  _cellButton_BTNC7 = (cell, row, enumObject, rowIndex) => {
    return this._cellButtonWarehouseOUT(row.BTN_Warehouse, "InC7");
  };
  _cellButton_BTNC8 = (cell, row, enumObject, rowIndex) => {
    return this._cellButtonWarehouseOUT(row.BTN_StorageIn, "InC8");
  };
  _cellButtonWH = (btn, file) => {
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.switchPopUpwarehouse.bind(null, "OUT")}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = <i></i>;
        break;
    }
    return <div>{btnShow}</div>;
  };
  _cellButtonWarehouseOUT = (btn, file) => {
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.switchPopUpwarehouse.bind(null, "IN")}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = <i></i>;
        break;
    }
    return <div>{btnShow}</div>;
  };
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ products: data });
  };
  rowClassNameFormat = (row, rowIdx) => {
    return "";
  };
  onRowClick = (row, col, id) => {
    console.log(col, id);
    this.setState({ cellValue: row.T_Code });
    var Pr = this.state.products;
    this.setState({ WHRow: id });
    var j = 20;

    // ไม่ให้คีย์ข้ามแถว
    this.setState({ C1_editable: false });
    this.setState({ col: false });

    // จำนวนเต็มเวลาคลิก
    let T_Quantity = row.T_Quantity;
    if (col === 9 && T_Quantity !== "" && T_Quantity !== undefined) {
      row.T_Quantity = parseFloat(T_Quantity).toFixed(0);
    }

    for (var i = 0; i < Pr.length; i++) {
      Pr[i].BTN_Code = 0;
      Pr[i].BTN_Paybills = 0;
      Pr[i].BTN_Storage = 0;
      Pr[i].BTN_Warehouse = 0;
      Pr[i].BTN_StorageIn = 0;
    }

    // หาจากล่างขึ้นบน
    for (var i = this.state.products.length - 1; i >= 0; i--) {
      //หา แถวที่ว่างบนสุดใน products Table
      if (!this.state.products[i].T_Code) {
        j = i;
      }
    }

    // BTN ค้นหาได้เฉพาะในแถว
    if (col === 2) {
      Pr[id].BTN_Code = 1;
    }
    if ((col === 1 && j === id) || (col === 1 && row.T_Code !== undefined)) {
      this.setState({ C1_editable: true });
      /* this.setState({ col: true }); */
      Pr[id].BTN_Code = 1;
    } else if (
      col === 4 &&
      typeof row.T_Code !== "undefined" &&
      row.T_Code !== ""
    ) {
      this.setState({ productcodeinrow: row.T_Code });
      this.setState({ productcodeinrow1: row.treasury });
      Pr[id].BTN_Paybills = 1;
    } else if (
      col === 6 &&
      typeof row.T_Code !== "undefined" &&
      row.T_Code !== ""
    ) {
      this.setState({ productcodeinrow: row.T_Code });
      this.setState({ productcodeinrow1: row.treasury });
      Pr[id].BTN_Storage = 1;
    } else if (
      col === 10 &&
      typeof row.T_Code !== "undefined" &&
      row.T_Code !== ""
    ) {
      this.setState({ productcodeinrow: row.T_Code });
      this.setState({ productcodeinrow1: row.treasury });
      Pr[id].BTN_Warehouse = 1;
    } else if (
      col === 12 &&
      typeof row.T_Code !== "undefined" &&
      row.T_Code !== ""
    ) {
      this.setState({ productcodeinrow: row.T_Code });
      this.setState({ productcodeinrow1: row.treasury });
      Pr[id].BTN_StorageIn = 1;
    } else {
      try {
        this.setState({ C1_editable: false });
      } catch (err) {
        //console.log(err);
      }
    }

    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
      this.setState({ col: true });
    }
    this.setState({ products: Pr });
  };

  Get_PopUpItem = (code, data, stockCode) => {
    this.AddDataTable(code, this.state.TBLastClick - 1, stockCode);
  };

  Get_warehouse = async (data) => {
    var DataValue = data.split("|");
    console.log(DataValue);
    var Pr = this.state.products;
    var r = this.state.WHRow;
    Pr[r].treasury = DataValue[0];
    Pr[r].T_StorageOut = DataValue[2];
    // await Checkstock(Pr[r].T_Code, "", Pr[r].T_Unit_Code, DataValue[0], DataValue[2], 2).then(resstock => {
    //     Pr[r].MaxUnit = Number(resstock)
    // })
    setTimeout(() => {
      this.setState({ products: Pr });
    }, 500);
    if (this.state.warehouse) {
    }
    this.setState({ warehouse: true });
  };
  Get_warehouse2 = (data) => {
    var DataValue = data.split("|");
    var Pr = this.state.products;
    var r = this.state.WHRow;
    Pr[r].T_Warehouse = DataValue[0];
    Pr[r].T_StorageIn = DataValue[2];
    //  Pr[r].MaxUnit = DataValue[4];
    setTimeout(() => {
      this.setState({ products: Pr });
    }, 500);
  };

  setDataWarehouseToTable = (data) => {
    // data ควรเป็น object เช่น { T_Warehouse, T_StorageIn, ... }
    var Pr = this.state.products;
    var r = this.state.WHRow;
    if (typeof data === "object") {
      if (this.state.PopUpWHType === "IN") {
        Pr[r].T_Warehouse = data.WAREHOUSE;
        Pr[r].T_StorageIn = data.LOCATION;
      } else {
        Pr[r].treasury = data.WAREHOUSE;
        Pr[r].T_StorageOut = data.LOCATION;
      }

      // สามารถเพิ่ม field อื่น ๆ ได้ตามต้องการ เช่น Pr[r].MaxUnit = data.MaxUnit;
    }
    setTimeout(() => {
      this.setState({ products: Pr });
    }, 500);
  };

  AddDataTable = (ItemCode, row, stockCode) => {
    console.log(ItemCode, row, stockCode);
    var maxunit = 0;
    var j = rowNum;
    var col = this.state.products;
    var CSPRODUCT = "";
    if (stockCode === "0") {
      CSPRODUCT = "CSPRODUCT/ProductFullbycode?code=";
    } else if (stockCode === "1") {
      CSPRODUCT = "CSPRODUCT/GETSearchproduct?STOCKTYPE=1&checkCODE=true&txt=";
    }
    var url =
      CSPRODUCT + ItemCode + "&user=" + localStorage.getItem("Username");
    console.log(genURL(url));
    axios
      .get(genURL(url), { timeout: 3600 })
      .then(async (ref) => {
        console.log("ref xxxxxxxxxx", ref);

        if (row > -1) {
          j = row;
        }
        if (ref.data.length > 0) {
          // if (chk === true) {
          //รหัสซ้ำเพิ่มปริมาณ//
          for (var i = 0; i < col.length; i++) {
            console.log(col[i].T_Code, "===", ItemCode);
            if (col[i].T_Code === ItemCode) {
              if (col[i].T_Quantity <= ref.data[0].STOCKQTY) {
                col[i].T_Quantity = parseFloat(
                  Number(col[i].T_Quantity) + 1
                ).toFixed(2);
                this.setState({ products: col });
                this.ReLoadData();
                return;
              } else {
                col[i].T_Quantity = ref.data[0].STOCKQTY;
                this.setState({ products: col });
                this.ReLoadData();
              }
            }
          }
          col[j] = {
            C0: j + 1,
            T_Code: ref.data[0].CODE,
            BTN_Code: 0,
            T_List: ref.data[0].NAMETH,
            treasury: this.state.defaultwarehouse,
            T_StorageOut: this.state.defaultlocetion,
            T_Unit: ref.data[0].UNITNAME,
            T_Unit_Code: ref.data[0].STOCKUNIT,
            T_Quantity: parseFloat(0).toFixed(2),
            T_Warehouse: this.state.defaultendwarehouse,
            T_StorageIn: this.state.defaultendlocetion,
            stockCode: stockCode,
            MaxUnit: parseFloat(0).toFixed(2),
            STOCKTYPE: ref.data[0].STOCKTYPE,
            SERIALNUMBER: null,
            REFDOCNO: "",
            REFQTY: "0",
            MAINGROUP: ref.data[0].MAINGROUP,
          };
          this.setState({ products: [...col] });
          if (ref.data.length === 1 && ref.data[0].PRODUCTSET === 1) {
            j++;
            var url1 =
              "CSPRODUCTSET/Code?code=" +
              ItemCode +
              "&user=" +
              localStorage.getItem("Username");
            console.log(genURL(url1));
            axios
              .get(genURL(url1), { timeout: 3600 })
              .then((ref2) => {
                if (ref2.data.length > 0) {
                  for (var i = 0; i < ref2.data.length; i++) {
                    // Checkstock(ref2.data[i].CODE, "", ref.data[0].STOCKUNIT, this.state.siteCodeUser, this.state.siteCodeUser, Number(ref.data[0].MAINGROUP)).then(resstock => {
                    //     maxunit = parseFloat(resstock).toFixed(2)
                    //     console.log(maxunit);
                    // })
                    col[j] = {
                      C0: j + 1,
                      T_Code: ref2.data[i].PRODUCTCODE,
                      BTN_Code: col[i].BTN_Code,
                      T_List: ref2.data[i].PRODUCTNAME,
                      treasury: this.state.defaultwarehouse,
                      T_StorageOut: "",
                      // treasury : this.TreaSury.current.value ,
                      // T_StorageOut : this.Storagelocation.current.value,
                      //T_Unit: ref2.data[i].UNITCODE,
                      T_Unit: ref2.data[i].UNITNAME,
                      /* T_Quantity: parseFloat(1).toFixed(2), */
                      T_Warehouse: ref2.data[i].AMOUNT,
                      T_StorageIn: ref2.data[i].DISCAMOUNT,
                      T_Refer: ref2.data[i].AMOUNT - ref2.data[i].DISCAMOUNT,
                      C10: "",
                      MaxUnit: ref.data[0].STOCKQTY,
                      STOCKTYPE: ref.data[0].STOCKTYPE,
                      SERIALNUMBER: null,
                      REFDOCNO: "",
                      REFQTY: "0",
                    };
                    if (i === ref2.data.length - 1) {
                      this.setState({ products: col });
                      this.ReLoadData();
                    }
                    j++;
                  }
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          this.ReLoadData();
        } else {
          col[j] = {
            C0: j + 1,
          };
          this.setState({ products: col });
          this.ReLoadData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setTimeout(() => {
      document.getElementById("TableLoadItem").innerHTML = "";
    }, 5000);
  };

  ReLoadData = (directions) => {
    //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
    var col = this.state.products;
    var NewCol = [];
    var j = 0;
    for (var i = 0; i < col.length; i++) {
      if (col[i].T_Code) {
        console.log("newcol");
        NewCol[j] = col[i];
        console.log(col[i]);
        NewCol[j].C0 = j + 1;
        /*----------------------------------------------------คลัง-----*/
        if (
          col[i].treasury === "" ||
          col[i].T_StorageOut === "" ||
          directions === "Y1"
        ) {
          //   NewCol[j].treasury = this.TreaSury.current.value;
          //NewCol[j].T_StorageOut = this.Storagelocation.current.value;
        }
        if (
          col[i].treasury === "" ||
          col[i].T_StorageOut === "" ||
          directions === "Y2"
        ) {
          // NewCol[j].T_Warehouse = this.TreaSuryto.current.value;
          //  NewCol[j].T_StorageIn = this.Storagelocationto.current.value;
        }
        NewCol[j].BTN_Paybills = 0;
        NewCol[j].BTN_Storage = 0;
        NewCol[j].BTN_Warehouse = 0;
        NewCol[j].BTN_StorageIn = 0;

        j++;
      }
    }

    for (var i = j; i < col.length; i++) {
      NewCol[j] = { C0: j + 1 };
      j++;
    }
    this.setState({ products: NewCol });
  };

  /*----------------------------------------------------------------------------------------------------------------------------*/
  Switch_PopUpItem = (e, rowClick) => {
    this.setState({
      typeFullScreenDialog: e,
      TBLastClick: rowClick,
      openFullScreenDialog: true,
      titleFullScreenDialog: "ค้นหาสินค้า-product",
    });
  };
  Switch_OtherPopup = (type) => {
    this.setState({ OtPopupType: type });
    //  this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
    //----------------------- ใหม่
    switch (type) {
      case "Groupdata":
        if (this.state.productcodeinrow !== "") {
          //ชื่อ
          this.setState({ typeFullScreenDialog: type });
          //open
          this.setState({ openFullScreenDialog: true });
          //title
          this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" });
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบรหัสสินค้าในแถวที่ท่านเลือก" });
          return;
        }
        break;
    }
  };
  Switch_Report = (e) => {
    this.setState({ SwitchReport: !this.state.SwitchReport });
  };

  Switch_PopUpwarehouse = (type) => {
    // this.setState({ SwitchPopUpwarehouse: !this.state.SwitchPopUpwarehouse });
    // this.setState({ PopUpWHType: type });

    console.log("case ", type);
    switch (type) {
      case "InC3":
        if (this.state.productcodeinrow !== "") {
          //ชื่อ
          this.setState({ typeFullScreenDialog: type });
          //open
          this.setState({ openFullScreenDialog: true });
          //title
          this.setState({ titleFullScreenDialog: "เลือกคลังและตำแหน่งเก็บ" });
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบรหัสสินค้าในแถวที่ท่านเลือก" });
          return;
        }
        break;
    }
  };
  switchPopUpwarehouse = (type) => {
    console.log("case switchPopUpwarehouse", type);
    this.setState({ SwitchPopUpwarehouse: !this.state.SwitchPopUpwarehouse });
    this.setState({ PopUpWHType: type });
  };
  /*------------------------------------------------------------พิเศษ------------------------------------------------------------*/
  Switch_SELSTKMOVEREQ = (e) => {
    this.setState({ PopUpTYpeSELSTKMOVEREQ: e });
    this.setState({ SwitchSELSTKMOVEREQ: !this.state.SwitchSELSTKMOVEREQ });
  };

  reCheckData = async (type, val, fix) => {
    switch (type) {
      case "Groupdata":
        CheckCodeDocGroup(val, "CSSTKMOVE")
          .then((result) => {
            this.Groupdata_code.current.value = val;
            this.Groupdata.current.value = result;
            this.setState({ Groupdata_txt: result });
            //  console.log("result Groupdata", result);
          })
          .finally((_) => {
            // CheckTaxrate(val, "CSSALE").then(async (result) => {
            // this.TaxPersen.current.value = await result
            // if (fix === false) {
            //   this.GenerateDocno(value, "CSSALE")
            // }
            // })
          });
        break;
    }
  };

  _reCHK = async (RowData) => {
    var url = "CSSTKMOVE/GetBycodemain?code=" + RowData[0].docNo;
    // console.log(genURL(url));
    this.setState({
      openFullScreenDialog: false,
      openBackdrop: true,
    });
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        if (res.data !== "") {
          // this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
          this.reCheckData("Groupdata", res.data[0].DOCGROUP, true);
          this.onAddValue("Csuser", res.data[0].USERCODE);
          this.setState({ SaleDate: ReDate(res.data[0].DOCDATE) });
          this.DeliNumber.current.value = res.data[0].DOCNO;
          this.Remark.current.value = res.data[0].REMARK;

          this.MileNo.current.value = res.data[0].MileNo;
          this.TransferName.current.value = res.data[0].TransferName;
          this.SerialNo.current.value = res.data[0].SerialNo;
          this.Ref_docno.current.value = res.data[0].Ref_docno;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    var url1 = "CSSTKMOVE/GetBycodesub?code=" + RowData[0].docNo;
    console.log(genURL(url1));
    await axios
      .get(genURL(url1), { timeout: 3600 })
      .then((res) => {
        var data = this.state.products;
        for (var i = 0; i < res.data.length; i++) {
          data[i].T_Code = res.data[i].PRODUCTCODE;
          data[i].T_List = res.data[i].PRODUCTNAME;
          data[i].treasury = res.data[i].WAREHOUSE;
          data[i].T_StorageOut = res.data[i].LOCATION;
          data[i].T_Unit = res.data[i].UNITCODE;
          data[i].T_Unit_Code = res.data[i].UNITCODE;
          data[i].T_Quantity = res.data[i].QUANTITY;
          data[i].T_Warehouse = res.data[i].WAREHOUSEIN;
          data[i].T_StorageIn = res.data[i].LOCATIONIN;
          if (i === res.data.length - 1) {
            this.setState({ products: data });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

    this.setState({
      openBackdrop: false,
    });
  };
  Get_SELSTKMOVEREQ = async (data0) => {
    this.setState({ openFullScreenDialog: false });
    var col = this.state.products;
    var data = [];
    var j = this.state.products.length;
    for (var i = 0; i < data0.length; i++) {
      var url =
        "CSPRODUCT/Code?code=" +
        data0[i].Col1 +
        "&user=" +
        localStorage.getItem("Username");
      console.log(genURL(url));
      var MAINGROUP = "";
      await axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          if (res.data.length > 0) {
            MAINGROUP = res.data[0].MAINGROUP;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      var MaxUnit = 0;
      await Checkstock(
        data0[i].Col1,
        "",
        data0[i].Col10,
        data0[i].Col3,
        data0[i].Col4,
        MAINGROUP,
        ""
      ).then(async (resstock) => {
        console.log(resstock);
        MaxUnit = (await resstock) ? Number(resstock) : 0;
      });
      data[j] = {
        C0: j + 1,
        T_Code: data0[i].Col1,
        T_List: data0[i].Col2,
        treasury: data0[i].Col3,
        T_StorageOut: data0[i].Col4,
        T_Unit: data0[i].Col5,
        T_Quantity: data0[i].Col6,
        T_Warehouse: data0[i].Col7,
        T_StorageIn: data0[i].Col8,
        T_Refer: data0[i].Col9,
        T_Unit_Code: data0[i].Col10,
        REFDOCNO: data0[i].REFDOCNO,
        REFQTY: data0[i].REFQTY,
        STOCKTYPE: data0[i].STOCKTYPE,
        MaxUnit: MaxUnit,
      };
      await col.push(data[j]);
      j++;
    }
    const result = [];
    const map = new Map();
    for (const item of col) {
      if (!map.has(item.T_Code)) {
        map.set(item.T_Code, true); // set any value to Map
        if (item.T_Code) {
          result.push({
            C0: "",
            T_Code: item.T_Code,
            T_List: item.T_List,
            treasury: item.treasury,
            T_StorageOut: item.T_StorageOut,
            T_Unit: item.T_Unit,
            T_Quantity: item.T_Quantity,
            T_Warehouse: item.T_Warehouse,
            T_StorageIn: item.T_StorageIn,
            T_Refer: item.T_Refer,
            T_Unit_Code: item.T_Unit_Code,
            REFDOCNO: item.REFDOCNO,
            REFQTY: item.REFQTY,
            STOCKTYPE: item.STOCKTYPE,
            MaxUnit: item.MaxUnit,
          });
        }
      }
    }
    console.log(result);
    var table = [];
    for (let i = 0; i < result.length + 15; i++) {
      if (i < result.length) {
        console.log(result[i].WTAXRATE);
        table[i] = await {
          C0: i + 1,
          T_Code: result[i].T_Code,
          T_List: result[i].T_List,
          treasury: result[i].treasury,
          T_StorageOut: result[i].T_StorageOut,
          T_Unit: result[i].T_Unit,
          T_Quantity: Number(result[i].T_Quantity).toFixed(2),
          T_Warehouse: result[i].T_Warehouse,
          T_StorageIn: result[i].T_StorageIn,
          T_Refer: result[i].T_Refer,
          T_Unit_Code: result[i].T_Unit_Code,
          REFDOCNO: result[i].REFDOCNO,
          REFQTY: result[i].REFQTY,
          STOCKTYPE: result[i].STOCKTYPE,
          MaxUnit: result[i].MaxUnit,
        };
      } else {
        table[i] = {
          C0: i + 1,
        };
      }
    }
    this.setState({ products: await table });
    this.ReLoadData();
  };

  _print = () => {
    if (this.DeliNumber.current.value !== "") {
      //console.log("if Ec");
      this._callForm(this.DeliNumber.current.value);
    } else {
      //console.log("else Ec");

      return;
    }
  };
  _callForm = (vel) => {
    let url1 = "https://csrpt.pspl.co.th/jasperserver/";
    let url2 =
      "&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf";
    let url3 = "&docno=" + vel;
    this.setState({
      urlsend:
        url1 +
        "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FCSSTKMOVEMC&standAlone=true" +
        url2 +
        url3,
    });

    setTimeout(() => {
      this.switchshowform();
    }, 100);
  };
  switchshowform = (e) => {
    this.setState({ showform: !this.state.showform });
  };
  ClickDocgroup = (e) => {
    //console.log(this.Groupdata_code.current.value);
    this.Groupdata.current.value = this.Groupdata_code.current.value;
  };
  onBlur = () => {
    this.Groupdata.current.value = this.state.Groupdata_txt;
  };
  /* ลบข้อมูลใน table */
  onAfterSaveCell = async (row, cellName, cellValue) => {
    // ทศนิยม 2 ตำแหน่ง จำนวนเงิน
    setTimeout(() => {
      row.BTN_Code = "0";
    }, 500);
    if (row.T_Code) {
      if (
        cellName === "T_Quantity" &&
        Number(cellValue) > 0 &&
        Number(row.MAINGROUP) <= 2
      ) {
        await Checkstock(
          row.T_Code,
          "",
          row.T_Unit_Code,
          row.treasury,
          row.T_StorageOut,
          row.MAINGROUP,
          ""
        ).then(async (resstock) => {
          console.log("resstock", resstock);
          if (Number(row.T_Quantity) > Number(resstock)) {
            if (Number(resstock) > 0) {
              row.T_Quantity = await parseFloat(resstock).toFixed(2);
            } else {
              row.T_Quantity = await parseFloat(0).toFixed(2);
            }
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                row.T_Code +
                " จำกัดสินค้าไม่พอใช้งาน ในคลังมีจำนวน " +
                resstock +
                " " +
                row.T_Unit,
            });
          } else {
            row.T_Quantity = await parseFloat(row.T_Quantity).toFixed(2);
            this.ReLoadData();
          }
        });
      } else {
        row.T_Quantity = parseFloat(row.T_Quantity).toFixed(2);
      }
    }

    var cellValue1 = this.state.cellValue;
    if (cellName === "T_Code" && cellValue !== "" && cellValue1 !== cellValue) {
      var col = this.state.products;
      col[row.C0 - 1] = [];
      col[row.C0 - 1].C0 = row.C0;
      // col[row.C0 - 1].BTN_Code = row.BTN_Code;
      this.setState({ products: col });
      var url =
        "CSPRODUCT/ProductFullbycode?code=" +
        cellValue +
        "&user=" +
        localStorage.getItem("Username");
      console.log(genURL(url));
      axios
        .get(genURL(url), { timeout: 6000 })
        .then((res) => {
          console.log("xxxxxxxxxxxxx", res.data.STOCKTYPE);
          // var code = ""
          // if (res.data.length === 1) {
          //     code = "0"
          // } else {
          //     code = "1"
          // }
          // console.log("xxxxres.data", res.data)
          if (res.data.length > 0) {
            this.AddDataTable(
              cellValue,
              row.C0 - 1,
              res.data[0].STOCKTYPE.toString()
            );
          } else {
            this.setState({
              autoClose: 5000,
              opensnackbar: true,
              color: "warning",
              icon: ErrorIcon,
              messagealert:
                "สินค้ารหัส : (" +
                cellValue +
                ") ไม่มีในระบบกรุณาตราจสอบอีกครั้ง *** ในการณีใช้เครื่องแสกนกรุณาตรวจสอบภาษาการป้อนข้อมูลเป็นภาษาอังกฤษเท่านั้น ",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" });
        });
    } else if (cellName === "T_Code" && cellValue === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 500);
    }
    if (
      (cellName === "treasury" || cellName === "T_StorageOut") &&
      cellValue !== ""
    ) {
      var col = this.state.products;
      var select = "0";
      if (cellName === "T_StorageOut") {
        select = "1";
      }
      console.log(row.T_Code, cellValue, select);
      this._loadData(row.T_Code, cellValue, select).then((res) => {
        if (res) {
          var maxunit = col[row.C0 - 1].MaxUnit;
          col[row.C0 - 1].treasury = res.WAREHOUSE;
          col[row.C0 - 1].T_StorageOut = res.LOCATION;
          // Checkstock(row.T_Code, "", row.T_Unit_Code, res.WAREHOUSE, res.WAREHOUSE, Number(row.MAINGROUP)).then(resstock => {
          //     maxunit = parseFloat(resstock).toFixed(2)
          //     console.log(resstock);
          //     col[row.C0 - 1].MaxUnit = maxunit
          // })
        } else {
          col[row.C0 - 1].treasury = "";
          col[row.C0 - 1].T_StorageOut = "";
          // col[row.C0 - 1].MaxUnit = "0"
          col[row.C0 - 1].T_Quantity = "0.00";
        }
        this.setState({ products: [...col] });
      });
    }

    // คลังเข้า
    if (
      (cellName === "T_Warehouse" || cellName === "T_StorageIn") &&
      cellValue !== ""
    ) {
      var col = this.state.products;
      var selectIn = "0";
      if (cellName === "T_StorageIn") {
        selectIn = "1";
      }
      console.log(row.T_Code, cellValue, selectIn);

      // return

      //--------------------------------------
      let url =
        `STKWAREHOUSE/CSVSTKWarehouseaspermission?usercode=` +
        this.state.usercode +
        `&productcode=` +
        row.T_Code;
      let T_Warehouse, T_StorageIn;
      await axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          if (res.data.length > 0) {
            for (let index = 0; index < res.data.length; index++) {
              if (
                cellName === "T_Warehouse" &&
                res.data[index].WAREHOUSE === cellValue
              ) {
                T_Warehouse = res.data[index].WAREHOUSE;
                T_StorageIn = res.data[index].LOCATION;
              }
              if (
                cellName === "T_StorageIn" &&
                res.data[index].LOCATION === cellValue
              ) {
                T_Warehouse = res.data[index].WAREHOUSE;
                T_StorageIn = res.data[index].LOCATION;
              }
            }
            col[row.C0 - 1].T_Warehouse = T_Warehouse;
            col[row.C0 - 1].T_StorageIn = T_StorageIn;
            this.setState({ products: [...col] });
          }
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
        })
        .finally(() => {
          //--------------------------------------check ผูกคลัง
          //https://psaccmtapi.pspl.co.th/csstkwarehouses/stkwarehouse?unitcode=02&warehouse=1001&location=1001001&productcode=000104&jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NjY0MzY1NTUsIlVzZXIiOnsiQ09ERSI6IjYzMDE0IiwiU0lURUNPREUiOiIxMDk5IiwiVVNFUkdST1VQIjoiIn19.pNPrHKeKaV34rpy8GHhF2Ed6ImfHtHWSMh7wXstcDZ4&api_key=eNGLtwXPd8hKPre0H4nBaqHMiYp7kpGPhnypqjdW
          console.log("res checkimporturl");
          let checkimporturl =
            `csstkwarehouses/stkwarehouse?unitcode=` +
            row.T_Unit_Code +
            `&productcode=` +
            row.T_Code +
            `&warehouse=` +
            T_Warehouse +
            `&location=` +
            T_StorageIn;
          console.log("res checkimporturl", genURL(checkimporturl));
          axios.get(genURL(checkimporturl), { timeout: 3600 }).then((res) => {
            if (res.data.length > 0) {
              console.log("res checkimporturl", res.data[0].productcode);
              if (row.T_Code !== res.data[0].productcode) {
                col[row.C0 - 1].T_Warehouse = "";
                col[row.C0 - 1].T_StorageIn = "";
                this.setState({ products: [...col] });
              }
              // else {
              //     this.setState({ opensnackbar: true })
              //     this.setState({ color: "warning" })
              //     this.setState({ icon: ErrorIcon })
              //     this.setState({ messagealert: "กรุณาตรวจสอบคลังเข้า" })
              // }
            }
          });
        });
    }
  };
  onSearch = () => {
    var data = this.state.products;
    for (var i = 0; i < data.length; i++) {
      data[i].T_Code = "";
      data[i].T_List = "";
      data[i].treasury = "";
      data[i].T_StorageOut = "";
      data[i].T_Unit = "";
      data[i].T_Unit_Code = "";
      data[i].T_Quantity = "";
      data[i].T_Warehouse = "";
      data[i].T_StorageIn = "";
      data[i].T_Refer = "";
      data[i].discount = "";
      data[i].C10 = "";
      this.setState({ products: data });
    }
  };
  SelectSetData = (type, data) => {
    switch (type) {
      case "Calendar":
        this.setState({ SaleDate: data });
        break;
      default:
        break;
    }
  };
  onAddValue = async (type, value, Fix) => {
    if (value) {
      switch (type) {
        case "Groupdata":
          Checkdocgroup(value, "CSSTKMOVE", Fix)
            .then(async (result) => {
              if (result !== "") {
                this.Groupdata_code.current.value = value;
                this.Groupdata.current.value = result;
                this.setState({ Groupdata_txt: result });
                if (Fix !== "Y") {
                  await Chackdocno(value, "CSSTKMOVE")
                    .then((result1) => {
                      if (result1 !== "") {
                        this.DeliNumber.current.value = result1;
                      } else {
                        this.DeliNumber.current.value = "";
                      }
                    })
                    .catch((err) => {
                      this.DeliNumber.current.value = "";
                      console.log(err);
                    });
                }
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล" });
                this.Groupdata_code.current.value = "";
                this.Groupdata.current.value = "";
                this.setState({ Groupdata_txt: "" });
                this.DeliNumber.current.value = "";
              }
            })
            .catch((err) => {
              this.Groupdata_code.current.value = "";
              this.Groupdata.current.value = "";
              this.setState({ Groupdata_txt: "" });
              this.DeliNumber.current.value = "";
              console.log(err);
            });
          break;
        case "Csuser":
          await CheckUser(value)
            .then(async (result) => {
              if (result !== "") {
                this.Csuser_code.current.value = await value;
                this.Csuser.current.value = await result;
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล" });
                this.Csuser.current.value = "";
              }
            })
            .catch((err) => {
              this.Csuser_code.current.value = "";
              this.Csuser.current.value = "";
              console.log(err);
            });
          break;
        default:
          break;
      }
    }
  };
  Chackdoc = () => {
    Chackdocno(this.Groupdata_code.current.value, "CSSTKMOVE")
      .then(async (result1) => {
        if (result1 !== undefined) {
          this.DeliNumber.current.value = await result1;
        } else {
          this.DeliNumber.current.value = "";
        }
      })
      .catch((err) => {
        this.DeliNumber.current.value = "";
        console.log(err);
      });
  };
  onClick = (e) => {
    if (e.target.value !== "") {
      switch (e.target.name) {
        case "Groupdata":
          this.Groupdata.current.value = this.Groupdata_code.current.value;
          break;
        default:
          break;
      }
    }
  };
  onKeyDown = (e) => {
    if (e.key === "Enter") {
      if (e.target.name === "Groupdata") {
        this.onAddValue("Groupdata", e.target.value);
      }
    }
  };
  onChange = (e) => {
    switch (e.target.name) {
      case "Groupdata":
        if (e.target.value === "") {
          this.setState({ Groupdata_txt: "" });
          this.Groupdata_code.current.value = "";
          this.DeliNumber.current.value = "";
        }
        break;
      default:
        break;
    }
  };
  onBlur = (e) => {
    if (e.target.name === "Groupdata") {
      this.Groupdata.current.value = this.state.Groupdata_txt;
    }
  };
  _loadData = async (productcodeinrow, value, Search) => {
    var result = "";
    var SearchCode = "";
    if (Search === "0") {
      SearchCode = "&warehouse=" + value;
    }
    if (Search === "1") {
      SearchCode = "&location=" + value;
    }
    var url =
      "STKWAREHOUSE/Search?productcode=" + productcodeinrow + SearchCode;
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        if (res.data.length > 0) {
          result = {
            WAREHOUSE: res.data[0].WAREHOUSE,
            LOCATION: res.data[0].LOCATION,
          };
        }
      })
      .catch((error) => {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
      });
    return result;
  };
  onClickTopbar = (e) => {
    console.log(e);
    switch (e) {
      case "save":
        this.saveData();
        break;
      case "new":
        this.ReplacePage(window.location.pathname + location.search);

        break;
      case "print":
        this._print(null);
        break;
      case "search":
        //this.setState({ SwitchSearchDoc: true });
        this.setState({
          openFullScreenDialog: true,
          titleFullScreenDialog: "ค้นหาใบขอโอนสินค้า",
          typeFullScreenDialog: "SearchDoc",
        });
        break;
      case "SELSTKMOVEREQ":
        //this.Switch_SELSTKMOVEREQ("SELSTKMOVEREQ")
        this.setState({
          PopUpTYpeSELSTKMOVEREQ: "SELSTKMOVEREQ",
          openFullScreenDialog: true,
          titleFullScreenDialog: "เลือกใบขอโอนสินค้า",
          typeFullScreenDialog: "SELSTKMOVEREQ",
        });

        break;
      default:
        break;
    }
  };
  rescustomInput = (data, type) => {
    if (data.source === "CSWAREHOUSEALL" && type === "start") {
      console.log("test rescustomInput", data, type);
      this.setState({ defaultwarehouse: data.warehouse });
      this.setState({ defaultlocetion: data.location });
    }
    if (data.source === "CSWAREHOUSEALL" && type === "end") {
      console.log("test rescustomInput", data, type);
      this.setState({ defaultendwarehouse: data.warehouse });
      this.setState({ defaultendlocetion: data.location });
    }
  };

  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
  };

  _printReport = (docno) => {
    try {
      if (formPrintdata.length > 1) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({
          messagealert:
            "กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length,
        });
        return;
      }
    } catch (error) {
      console.log("error", error);
    }

    if (this.state.reporturl !== "") {
      this.setState({
        openReportFullScreenDialog: true,
        titleReportFullScreenDialog: "พิมพ์ใบโอนสินค้า",
        urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docno}`,
      });
    } else {
      this.ReplacePage(window.location.pathname + location.search);
    }
  };
  CloseReportDialog = (e) => {
    this.setState({ openReportFullScreenDialog: e });
    this.ReplacePage(window.location.pathname + location.search);
  };

  ReplacePage = (e) => {
    this.setState({ openBackdrop: false });
    window.location.replace(e);
  };

  render() {
    const type = this.state.typeFullScreenDialog;
    return (
      <div
        className="PSApp"
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        onChange={this.onChange}
        onBlur={this.onBlur}
      >
        <FullScreenDialognew
          open={this.state.openReportFullScreenDialog}
          title={this.state.titleReportFullScreenDialog}
          CloseDialog={(e) => this.CloseReportDialog(e)}
        >
          <Repostview url={this.state.urlsend} />
        </FullScreenDialognew>
        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.setState({ openFullScreenDialog: e })}
        >
          {type === "SearchDoc" ? (
            <Rechecked Dataselect={(e) => this._reCHK(e)} from="CSSTKMOVE" />
          ) : (
            ""
          )}
          {type === "SELSTKMOVEREQ" ? (
            <PopUpSELSTKMOVEREQ
              closePopup={this.Switch_SELSTKMOVEREQ}
              Get_SELSTKMOVEREQ={this.Get_SELSTKMOVEREQ}
              type={this.state.PopUpTYpeSELSTKMOVEREQ}
            />
          ) : (
            ""
          )}
          {type === "InC3" ? (
            <PopUpwarehouse
              closePopup={(e) => this.CloseDialog(e)}
              type="setdefaultwarehouse"
              Get_PopUpOther={this.Get_warehouse}
              productcodeinrow={this.state.productcodeinrow}
              productcodeinrow1={this.state.productcodeinrow1}
              from="CSSTKMOVE"
            />
          ) : null}
          {type === "Groupdata" ? (
            <PopUpOther
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this.Get_PopUpOther}
              from="CSSTKMOVE"
              userSite={this.state.siteCodeUser}
            />
          ) : null}
          {this.state.typeFullScreenDialog === "SearchItem" ? (
            <PopUpItem
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUpItem={this.Get_PopUpItem}
              stockType={"1"}
              from="CSSTKMOVE"
            />
          ) : null}
        </FullScreenDialog>
        {this.state.SwitchPopUpwarehouse ? (
          <WarehouseTransfer
            closePopup={() => {
              this.setState({
                SwitchPopUpwarehouse: !this.state.SwitchPopUpwarehouse,
              });
            }}
            type={this.state.PopUpWHType}
            returnValue={this.setDataWarehouseToTable}
            productcodeinrow={this.state.productcodeinrow}
            from="CSSTKMOVE2"
          />
        ) : null}
        {this.state.showform ? (
          <PopUpReport close={this.switchshowform} url={this.state.urlsend} />
        ) : null}
        <Topbar
          listmenu={listmenu}
          title="บันทึกใบโอนสินค้า"
          onClick={(e) => this.onClickTopbar(e)}
        />
        <div className="PSAppfrom">
          <Grid>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Row className="show-grid">
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <MaterialUIPickers
                      title="วันที่ขอโอน"
                      DateValue={(e) => this.SelectSetData("Calendar", e)}
                      defaultdate={this.state.SaleDate}
                      open={this.state.checkenableInput["DOCDATE"]}
                    />
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">กลุ่มข้อมูล</span>
                        <input
                          type="text"
                          className="form-control hidden"
                          ref={this.Groupdata_code}
                        />
                        <input
                          type="text"
                          className="form-control"
                          name="Groupdata"
                          ref={this.Groupdata}
                          tabIndex={1}
                        />
                        <span
                          id="iconGroupdata"
                          className="input-group-addon icon"
                          onClick={this.Switch_OtherPopup.bind(
                            null,
                            "Groupdata"
                          )}
                        >
                          <i>
                            {" "}
                            <ArrowDropDownRoundedIcon fontSize="small" />
                          </i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">เลขที่ใบโอน</span>
                        <input
                          type="text"
                          className="form-control"
                          ref={this.DeliNumber}
                          disabled
                        />
                        <span
                          id="iconTaxNumber"
                          className="input-group-addon icon"
                        >
                          <i
                            className="fas fa-sync-alt"
                            onClick={() => this.Chackdoc()}
                          ></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={8} md={8} lg={8}>
                  <Row className="show-grid">
                    <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">หมายเหตุ</span>
                        <input
                          type="text"
                          className="form-control"
                          ref={this.Remark}
                          tabIndex={2}
                        />
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col xs={12} sm={4} md={4} lg={4}>
                  <Row className="show-grid">
                    <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <span className="input-group-addon">พนักงาน</span>
                        <input
                          type="text"
                          className="form-control hidden"
                          ref={this.Csuser_code}
                        />
                        <input
                          type="text"
                          className="form-control"
                          ref={this.Csuser}
                          disabled
                        />
                        <span
                          id="iconTaxNumber"
                          className="input-group-addon icon"
                        >
                          <i
                            className="fas fa-sync-alt"
                            onClick={() =>
                              this.onAddValue("Csuser", this.state.usercode)
                            }
                          ></i>
                        </span>
                      </div>
                    </div>
                  </Row>
                </Col>
              </Row>
            </Col>

            <MuiGrid
              container
              spacing={2}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <MuiGrid item xs={6}>
                <CustomInput
                  title="คลังเริ่มต้น"
                  disabledvalue={true}
                  of_title={false}
                  of_btn={false}
                  source={"CSWAREHOUSEALL"}
                  propsvalue={(e) => this.rescustomInput(e, "start")}
                  fullWidth={true}
                  id={"start"}
                />
              </MuiGrid>
              <MuiGrid item xs={6}>
                <CustomInput
                  title="คลังเข้า"
                  disabledvalue={true}
                  of_title={false}
                  of_btn={false}
                  source={"CSWAREHOUSEALL"}
                  propsvalue={(e) => this.rescustomInput(e, "end")}
                  fullWidth={true}
                  id={"end"}
                />
              </MuiGrid>
            </MuiGrid>
          </Grid>
        </div>
        <div className="PSAppTable">
          <div className="form-group col-md-12">
            <div className="form-row">
              <BootstrapTable
                data={this.state.products}
                trClassName="trClassName"
                tableHeaderClass="trClassName"
                options={{ noDataText: "...", onRowClick: this.onRowClick }}
                cellEdit={{
                  mode: "click",
                  blurToSave: true,
                  beforeSaveCell: this.onAfterSaveCell,
                }}
                height="400"
              >
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataField="C0"
                  isKey
                  width="30"
                  dataAlign="center"
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  colSpan="2"
                  dataAlign="left"
                  width="170"
                  className="colbuttomhidden"
                >
                  {" "}
                  <div align="center"> รหัสสินค้า </div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="T_Code"
                  editable={this.state.C1_editable}
                  dataAlign="left"
                  width="140"
                >
                  {" "}
                  <div align="center"></div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="BTN_Code"
                  editable={false}
                  dataAlign="center"
                  width="30"
                  dataFormat={this._cellButton.bind(this)}
                  columnClassName="columnClassNameFormat1"
                >
                  {/* <i id="TableLoadItem" style={{ fontSize: "10px" }}></i> */}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataField="T_List"
                  editable={false}
                  dataAlign="left"
                  width="160"
                >
                  {" "}
                  <div align="center"> ชื่อสินค้า </div>{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  colSpan="2"
                  dataAlign="center"
                  width="80"
                  className="colbuttomhidden"
                >
                  {" "}
                  คลังจ่าย{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="treasury"
                  editable={this.state.col}
                  dataAlign="center"
                  width="80"
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="BTN_Paybills"
                  editable={false}
                  dataAlign="center"
                  width="30"
                  dataFormat={this._cellButton_BTNC3.bind(this)}
                  columnClassName="columnClassNameFormat1"
                >
                  <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  colSpan="2"
                  dataAlign="center"
                  width="120"
                  className="colbuttomhidden"
                >
                  {" "}
                  ที่เก็บจ่าย{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="T_StorageOut"
                  editable={this.state.col}
                  dataAlign="center"
                  width="90"
                >
                  {" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="BTN_Storage"
                  editable={false}
                  dataAlign="center"
                  width="30"
                  dataFormat={this._cellButton_BTNC4.bind(this)}
                  columnClassName="columnClassNameFormat1"
                >
                  <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataField="T_Unit"
                  editable={false}
                  dataAlign="center"
                  width="80"
                >
                  {" "}
                  หน่วย{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataField="T_Quantity"
                  editable={this.state.col}
                  dataAlign="center"
                  width="80"
                >
                  {" "}
                  ปริมาณ{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  colSpan="2"
                  dataAlign="center"
                  width="120"
                  className="colbuttomhidden"
                >
                  {" "}
                  คลังเข้า{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="T_Warehouse"
                  editable={this.state.col}
                  dataAlign="center"
                  width="80"
                >
                  {" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="BTN_Warehouse"
                  editable={false}
                  dataAlign="center"
                  width="30"
                  dataFormat={this._cellButton_BTNC7.bind(this)}
                  columnClassName="columnClassNameFormat1"
                >
                  <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  colSpan="2"
                  dataAlign="center"
                  width="120"
                  className="colbuttomhidden"
                >
                  {" "}
                  ที่เก็บเข้า{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="T_StorageIn"
                  editable={this.state.col}
                  dataAlign="center"
                  width="90"
                >
                  {" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="BTN_StorageIn"
                  editable={false}
                  dataAlign="center"
                  width="30"
                  dataFormat={this._cellButton_BTNC8.bind(this)}
                  columnClassName="columnClassNameFormat1"
                ></TableHeaderColumn>
                <TableHeaderColumn dataField="T_Refer" hidden>
                  {" "}
                  อ้างอิง{" "}
                </TableHeaderColumn>
                {/* <i id="TableLoadItem" style={{ fontSize: "10px" }}></i> */}
                <TableHeaderColumn
                  row="0"
                  dataField="ssssT_Unit_Code"
                  editable={false}
                  width="80"
                  hidden
                >
                  T_Unit_Code
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  dataField="T_Unit_Code"
                  editable={false}
                  width="80"
                  hidden
                >
                  {" "}
                </TableHeaderColumn>
                {/* <TableHeaderColumn row="0" dataField='ssssMaxUnit' editable={false} width="80" hidden >MaxUnit</TableHeaderColumn> */}
                <TableHeaderColumn
                  row="0"
                  dataField="MaxUnit"
                  editable={false}
                  width="80"
                  hidden
                ></TableHeaderColumn>
                {/* <TableHeaderColumn row="0" dataField='REFDOCNO' editable={false} width="120" hidden>REFDOCNO</TableHeaderColumn> */}
                <TableHeaderColumn
                  row="0"
                  dataField="REFDOCNO"
                  editable={false}
                  hidden
                ></TableHeaderColumn>
                {/* <TableHeaderColumn row="0" dataField='REFQTY' editable={false} width="80" hidden>REFQTY</TableHeaderColumn> */}
                <TableHeaderColumn
                  row="0"
                  dataField="REFQTY"
                  editable={false}
                  width="80"
                  hidden
                ></TableHeaderColumn>
                {/* <TableHeaderColumn row="0" dataField='STOCKTYPE' editable={false} width="80" hidden>STOCKTYPE</TableHeaderColumn> */}
                <TableHeaderColumn
                  row="0"
                  dataField="STOCKTYPE"
                  editable={false}
                  width="80"
                  hidden
                ></TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
        {/* <div className='clearfix'> <hr></hr></div> */}
        <div className="PSAppTable">
          <Grid>
            <Col xs={12} sm={8} md={8} lg={8}>
              <Row className="show-grid">
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid"></Row>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid"></Row>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Row className="show-grid"></Row>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid"></Row>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <Row className="show-grid"></Row>
                </Col>
              </Row>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
              <Row className="show-grid">
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Row className="show-grid"></Row>
                </Col>
              </Row>
            </Col>
            <Row className="show-grid">
              <Col xs={12} sm={12} md={12} lg={12}>
                <Panel>
                  <Panel.Heading>
                    <Panel.Title componentClass="h5">
                      ข้อมูลเพิ่มเติม ( User's Field){" "}
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Row className="show-grid">
                        <Col xs={12} sm={12} md={12} lg={4}>
                          <div className="row">
                            <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon ">
                                  {" "}
                                  เลขไมล์
                                </span>
                                <input
                                  type="number"
                                  className="form-control Price"
                                  ref={this.MileNo}
                                />
                              </div>
                            </div>
                            <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon ">
                                  {" "}
                                  หมายเลขตัวถัง
                                </span>
                                <input
                                  type="text"
                                  className="form-control "
                                  ref={this.SerialNo}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={4}>
                          <div className="row">
                            <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon ">
                                  {" "}
                                  ผู้รับโอน
                                </span>
                                <input
                                  type="text"
                                  className="form-control "
                                  ref={this.TransferName}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={4}>
                          <div className="row">
                            <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <span className="input-group-addon ">
                                  &nbsp;อ้างอิงขอโอนเลขที่&nbsp;{" "}
                                </span>
                                <input
                                  type="text"
                                  className="form-control "
                                  ref={this.Ref_docno}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Panel.Body>
                </Panel>
              </Col>
            </Row>
          </Grid>
          <Snackbar
            place="br"
            color={this.state.color}
            icon={this.state.icon}
            autoClose={this.state.autoClose}
            message={this.state.messagealert}
            open={this.state.opensnackbar}
            closeNotification={() => {
              this.setState({ opensnackbar: false });
            }}
            close
          />
        </div>
      </div>
    );
  }
}
